export default __webpack_public_path__ + "static/media/raimond-klavins-HbN5sXoMtAA-unsplash.5d67c79f.jpg";